<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="10">
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="센서타입">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="objTypeList" option-key="label, objtypeName" property="objtypeId" labelprop="objtypeName"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="센서명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="수집방식">
                    <w-text-form :modifiable="false" :target="formData" property="rscGetmethodName"> </w-text-form>
                  </el-form-item>
                  <!-- <el-form-item v-if="isSQL" label="데이터소스">
                  <w-select-form :modifiable="modifiable" :target="formData" :option-list="rscGetmethodsSources" option-key="sourceId" property="sourceId" labelprop="sourceName">
                  </w-select-form>
                </el-form-item> -->
                  <el-form-item v-if="isRtu" label="RTU 정보">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="rtuDeviceList" option-key="parentObjId" property="parentObjId" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="IP" prop="ipaddress">
                    <w-text-form :modifiable="modifiableRtu" :target="formData" property="ipaddress"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="포트">
                    <w-number-form :modifiable="modifiableRtu" :target="formData" property="parentSnmpPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">장비 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <!-- <el-form-item label="제조사">
                  <w-select-form search=true :modifiable="modifiable" :target="formData" @change="companyChange" :option-list="objCompanyList" option-key="objCompanyId" property="objCompanyId" labelprop="objCompanyName">
                  </w-select-form>
                </el-form-item>
                <el-form-item label="모델">
                  <w-select-form search=true :modifiable="modifiable" :target="formData" :option-list="filteredProducts" option-key="objCompanyId, objProductId" property="objProductId" labelprop="objProductId">
                  </w-select-form>
                </el-form-item> -->
                  <!-- <el-form-item label="제품코드">
                  <w-text-form :modifiable="false" :target="formData" property="cpuModel">
                  </w-text-form>
                </el-form-item>
                <el-form-item label="시리얼번호">
                  <w-text-form :modifiable="false" :target="formData" property="cpuModel">
                  </w-text-form>
                </el-form-item> -->
                  <el-form-item label="센서 정보">
                    <w-text-form :modifiable="modifiable" :target="formData" property="sensorInfo" type="textarea"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger" v-if="!isRtu || isSnmpv3">
            <el-row v-if="!isRtu" class="mr-b30">
              <div class="title-h4 title-bar">SNMP 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="커뮤니티 읽기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityRead" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="커뮤니티 읽기/쓰기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityReadwrite" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="버전">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="snmpVersionList" option-key="snmpVersion" property="snmpVersion" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="포트">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpPort"> </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isSnmpv3" class="list form-list">
                <el-form v-if="isSnmpv3" :model="formData" label-width="120px">
                  <el-form-item label="USER">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3Username"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context 명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Auth 프로토콜">
                    <w-select-form @change="authChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3AuthList" option-key="snmpV3AuthProtocol" property="snmpV3AuthProtocol" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Auth 비밀번호">
                    <w-text-form :modifiable="hasAutoProtocol" :target="formData" property="snmpV3AuthPassword" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Privacy 프로토콜">
                    <w-select-form @change="privChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3PrivList" option-key="snmpV3PrivProtocol" property="snmpV3PrivProtocol" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Privacy 비밀번호">
                    <w-text-form :modifiable="hasPrivProtocol" :target="formData" property="snmpV3PrivPassword" type="password"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="spanInteger">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { has, isEmpty, isNil, eq, assign } from 'lodash';

import { EMPTY_TEXT } from '@/utils/string';
import MsgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
// api
import sensorInfoAPI from '@/api/config/sensor/sensor-info';
import commonAPI from '@/api/config/common';

// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import wManagerTreeForm from '@/components/formeditor/MgrTreeSelectEditor';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

export default {
  name: 'w-config-status',
  props: ['nodeParams'],
  components: {
    sensorInfoAPI,
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    wManagerTreeForm,
    WObjImportanceFormEditor,
  },
  data() {
    return {
      isLoading: true,
      spanInteger: 12,
      false: false,
      // Reject데이터
      objOriginData: {},
      formData: {},
      objTypeList: [],
      managerList: [],
      objCompanyList: [],
      objProductList: [],
      snmpVersionList: [],
      snmpV3AuthList: [],
      snmpV3PrivList: [],
      rtuDeviceList: [],
      basicDataLoadFlag: false,
      // rscGetmethods: [],
      // rscGetmethodsSources: []
    };
  },
  computed: {
    params() {
      return {
        objId: this.nodeParams.objId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    filteredProducts() {
      return this.objProductList.filter((c) => c.objCompanyId === this.formData.objCompanyId);
    },
    isSQL() {
      const rscGetmethodId = this.formData.rscGetmethodId;
      return !isNil(rscGetmethodId) && rscGetmethodId === 'SQL';
    },
    isRtu() {
      return eq('RTU', this.formData.parentObjtypeId) ? true : this.false;
    },
    modifiableRtu() {
      return eq(this.isRtu, true) ? this.false : this.modifiable;
    },
    isSnmpv3() {
      return eq('V3', this.formData.snmpVersion) ? true : this.false;
    },
    hasAutoProtocol() {
      return !eq('NONE', this.formData.snmpV3AuthProtocol) ? this.modifiable : this.false;
    },
    hasPrivProtocol() {
      return !eq('NONE', this.formData.snmpV3PrivProtocol) ? this.modifiable : this.false;
    },
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        if (this.params.objId) {
          this.loadData();
        }
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;

                  const updateDate = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    ipaddressApplytype: infoParams.ipaddressApplytype,
                    objCompanyId: infoParams.objCompanyId,
                    fmsSensorId: infoParams.fmsSensorId,
                    parentObjId: infoParams.parentObjId,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                  };
                  if (infoParams.ipaddressApplytype === 'IPv4') {
                    updateDate.ipaddressIpv4 = infoParams.ipaddressIpv4;
                  } else if (infoParams.ipaddressApplytype === 'IPv6') {
                    updateDate.ipaddressIpv6 = infoParams.ipaddressIpv4;
                  }

                  // 수정된값들
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateDate[key] = formData[key];
                      if (key === 'ipaddress') {
                        updateDate.ipaddressApplytype = formData.ipaddressApplytype;
                      }

                      if (eq('snmpV3AuthProtocol', key) && eq(formData[key], 'NONE')) {
                        updateDate.snmpV3AuthPassword = '';
                      }

                      if (eq('snmpV3PrivProtocol', key) && eq(formData[key], 'NONE')) {
                        updateDate.snmpV3PrivPassword = '';
                      }
                    });
                  }

                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateDate.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateDate, ['snmpCommunityRead', 'snmpCommunityReadwrite', 'snmpV3AuthPassword', 'snmpV3PrivPassword']);
                  if (encryptTargetData !== null) {
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateDate, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateDate, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    loadData() {
      this.isLoading = true;
      if (!this.basicDataLoadFlag) {
        this.setBasicData();
      }
      this.objOriginData = {};

      sensorInfoAPI
        .getSensorConfigInfoBasic(this.params)
        .then((result) => {
          if (result.data.success) {
            const data = result.data.data;

            if (data && !has(data, 'objCompanyId')) {
              // companyId 별로 모델을 필터링하는데
              // 처음부터 objCompanyId가 없을경우 computed watch 에서 catch못함
              data.objCompanyId = null;
            }

            if (isNil(data.snmpVersion)) {
              data.snmpVersion = 'NONE';
            }

            if (isNil(data.snmpV3AuthProtocol)) {
              data.snmpV3AuthProtocol = 'NONE';
            }

            if (isNil(data.snmpV3PrivProtocol)) {
              data.snmpV3PrivProtocol = 'NONE';
            }

            Object.assign(this.objOriginData, data);
            this.formData = Object.assign({}, this.objOriginData);
            if (this.isRtu && !this.isSnmpv3) {
              this.spanInteger = 12;
            } else {
              this.spanInteger = 8;
            }
            this.$emit('setConfigData', this.formData);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} updateDate [description]
     * @param  {[type]} action     [description]
     * @param  {[type]} target     [description]
     * @return {[type]}            [description]
     */
    saveConfig(updateDate, action, target) {
      sensorInfoAPI
        .updateSensorConfigInfo(updateDate)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            if (!isNil(result.data) && result.data.message === 'DuplicationException') {
              this.$message(MsgUtil.getCustomMsgData('센서명이 중복되었습니다. 센서명은 중복해서 설정할 수 없습니다.'));
            } else {
              this.$message(MsgUtil.getResultMsgData(action, target, false));
            }

            this.$store.dispatch('setSaveConfigEditing', false);
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
        });
    },
    convertObjtypeStr(value) {
      let str = value;
      if (isNil(str)) {
        return EMPTY_TEXT;
      }
      if (!eq(value, 'RTU')) {
        str = '자체수집';
      }
      return str;
    },
    companyChange() {
      this.formData.objProductId = null;
    },
    authChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3AuthPassword = null;
      }
    },
    privChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3PrivPassword = null;
      }
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
    setBasicData() {
      commonAPI
        .getObjTypeList({
          managetypeId: 'FMS',
        })
        .then((res) => {
          this.objTypeList = res.data.data;
        });

      commonAPI.getObjCompanyList({}).then((res) => {
        this.objCompanyList = res.data.data;
      });
      commonAPI.getObjProductList({}).then((res) => {
        this.objProductList = res.data.data;
      });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPVER',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpVersionList = [];

          list.forEach((data) => {
            snmpVersionList.push({
              label: data.basicinfoSubname,
              snmpVersion: data.basicinfoSubid,
            });
          });
          this.snmpVersionList = snmpVersionList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPAUTH',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3AuthList = [];
          list.forEach((data) => {
            snmpV3AuthList.push({
              label: data.basicinfoSubname,
              snmpV3AuthProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3AuthList = snmpV3AuthList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPPRIV',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3PrivList = [];

          list.forEach((data) => {
            snmpV3PrivList.push({
              label: data.basicinfoSubname,
              snmpV3PrivProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3PrivList = snmpV3PrivList;
        });

      sensorInfoAPI.getRtuDeviceInfo({}).then((res) => {
        this.rtuDeviceList = res.data.data;
      });

      this.basicDataLoadFlag = true;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/sensor/configstatus/index.vue